import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cust-percent",
  "use": "cust-percent-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" id=\"cust-percent\"><path d=\"M300-520q-58 0-99-41t-41-99 41-99 99-41 99 41 41 99-41 99-99 41m0-80q25 0 42.5-17.5T360-660t-17.5-42.5T300-720t-42.5 17.5T240-660t17.5 42.5T300-600m360 440q-58 0-99-41t-41-99 41-99 99-41 99 41 41 99-41 99-99 41m0-80q25 0 42.5-17.5T720-300t-17.5-42.5T660-360t-42.5 17.5T600-300t17.5 42.5T660-240m-444 80-56-56 584-584 56 56z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol